import React, { FC } from 'react';
import classnames from 'classnames';
import { getItemLabel } from '../../../../../utils/path';
import { FileLabeledThumbnail } from '../../FileLabeledThumbnail';
import styles from '../FileThumbnail.scss';
import { IFileThumbnail } from '../../types';

export const ZipThumbnail: FC<IFileThumbnail> = ({
  file,
  className,
  width,
  height,
  dataHook = 'document-zip-thumbnail',
  labelClassName,
  thumbnailSize,
  saveRef,
  wrapperStyle,
}) => (
  <FileLabeledThumbnail
    className={classnames(styles.thumbnail, styles.zip, styles[thumbnailSize], className)}
    label={`.${getItemLabel(file)}`}
    width={width}
    height={height}
    labelClassName={labelClassName}
    saveRef={saveRef}
    dataHook={dataHook}
    style={wrapperStyle}
  />
);
